<template>
  <v-container>
      <v-row>
          <v-col>
              <v-row justify="center">
                <v-card width="60%" flat class="mt-10">
                    <v-form>
                        <v-text-field
                            class="mt-6"
                            outlined
                            dense
                            label="Menu id"
                            color="primary"
                            v-model="id"
                        ></v-text-field>
                        <v-text-field
                            class="mt-6"
                            outlined
                            dense
                            label="Menu name"
                            v-model="name"
                            color="primary"
                        ></v-text-field>
                        <v-text-field
                            class="mt-6"
                            outlined
                            dense
                            label="price"
                            v-model="price"
                            color="primary"
                        ></v-text-field>
                        <v-select
                            class="mt-6"
                            :items="items"
                            label="Catorgory"
                            v-model="catagory"
                        ></v-select>
                        <v-textarea
                            class="mt-6"
                            outlined
                            v-model="description"
                            label="Menu description"
                        ></v-textarea>
                        <v-btn color="primary" width="100%" @click="submit">submit</v-btn>
                    </v-form>
                </v-card>
              </v-row>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import {mapActions} from "vuex"
export default {
    name: "upload_text",
    data() {
        return {
            id: "",
            name: "",
            price: "",
            catagory: "",
            description: "",
            items: ['Lunch & Dinner', 'Groups & Family Meals', 'Sandwiches', 'Vegetarian Dishes', 'Beverages', 'Appetizers & Sides'],
        }
    },
    methods: {
        ...mapActions(['upload_text']),
        submit() { 
            let item = {
                id: this.id,
                name: this.name,
                price: this.price,
                catagory: this.catagory,
                description: this.description
            }
            this.upload_text(item).then(result => {
                if(result.data.success) {
                    this.$router.push('/fullMenu')
                }
            }) 
  
           
        }
    }
}
</script>

<style>

</style>